import { render, staticRenderFns } from "./TheMultiPersonSearchTab.vue?vue&type=template&id=4d1704bf"
import script from "./TheMultiPersonSearchTab.vue?vue&type=script&lang=js"
export * from "./TheMultiPersonSearchTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports